import React, { useContext, useEffect, useState } from 'react'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  GridContainer,
  TextLabel,
  Text,
  TableContainer,
  Table,
  HeaderRow,
  HeaderCell,
  ItemRow,
  ItemCell,
  ButtonOfSection,
  ButtonOfSectionText,
  OptionsDiv,
  IconImg,
  DriverListDiv,
} from './style'
import ModalContext from '../../../../contexts/ModalContext'
import cross from '../../../../assets/orders/cross.svg'
import pen from '../../../../assets/router/edit-pen-white.svg'
import send from '../../../../assets/router/send.svg'
import share from '../../../../assets/router/share.svg'
import print from '../../../../assets/router/print.svg'
import correct from '../../../../assets/router/checked.svg'
import { RouterContext, Freight, Router } from '../../../../contexts/RouterContext'
import { headersLabel, inputs, freights } from './utils'
import { mock } from '../../freightContent/freightForm/utils'
import RouterSection from '../../../../pages/ClientPanel/router'
import SectionContext from '../../../../contexts/SectionContext'
import { useNavigate, useParams } from 'react-router-dom'
import { printRoutePdf } from '../../../PDF/Router/printRoutePdf'
import { ButtonCreate } from '../../style'
import axios from '../../../../config/axios'
import { FeedbackContext } from '../../../../contexts/FeedbackContext'
import ModalTest from '../../../BaseModal'
import { Copy } from 'lucide-react'

export interface RouterInterface {
  status: string
  Vehicle: any
  Freight: Freight[]
  date: string
  origin: string
  id: number
  track: string
  url: string
  responsible: string
}

export interface Driver {
  name: string
  phone: string
}

const RouterDetail = () => {
  const dataFormatter = (isoDateString: string): string => {
    if (!isoDateString) {
      return '' 
    }

    const dateUtc = new Date(isoDateString)


    if (isNaN(dateUtc.getTime())) {
      console.error('Data ISO inválida recebida:', isoDateString)
      return '' 
    }

    const getDrivers = async ()=>{
        const response = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/router/route/utils/drivers`)
        const drivers = response.data
        setDrivers(drivers)
    }

    const year = dateUtc.getUTCFullYear()
    const month = dateUtc.getUTCMonth() + 1 
    const day = dateUtc.getUTCDate()


    const formattedMonth = month < 10 ? `0${month}` : month
    const formattedDay = day < 10 ? `0${day}` : day

    return `${formattedDay}/${formattedMonth}/${year}`
  }
  const { setModalActive } = useContext(ModalContext)
  const { router, setRouter } = useContext(RouterContext)
  const { routerSection, setRouterSection } = useContext(SectionContext)
  const [shortUrl, setShortUrl] = useState<string>('')
  const { setFeedback } = useContext(FeedbackContext)
  const [drivers, setDrivers] = useState<Driver[]>([])
  const [visibleDriver, setVisibleDriver] = useState<boolean>(false)
  const [visibleCopy, setVisibleCopy] = useState<boolean>(false)
  const navigate = useNavigate()
  const { routerId } = useParams<{ routerId: string }>()
  const [isPrinting, setIsPrinting] = useState(false)
  const [isLoadingRouter, setIsLoadingRouter] = useState(false)
  const [routerModel, setRouterModel] = useState({
    status: router?.status || '',
    Vehicle: router?.Vehicle || null,
    Freight: router?.Freight || [],
    date: router?.date || '',
    origin: router?.origin || '',
    id: router?.id || 0,
    track: router?.track,
    responsible: router?.responsible,
  })

  const close = () => {

    setRouter(null)
    navigate('/panel/router/routers')
  }

  const handleEdit = () => {
    setModalActive(false)
    setRouterSection('newRouter')
    navigate('/panel/router/routers/edit')
  }

  const getDrivers = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/route/utils/drivers`,
    )
    const drivers = response.data
    setDrivers(drivers)
  }

  useEffect(() => {
    const fetchDrivers = async () => {
      await getDrivers()
    }
    fetchDrivers()
  }, [])

  useEffect(() => {
    if (router || !routerId) return

    const fetchRouter = async () => {
      setIsLoadingRouter(true)
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/route/${routerId}`,
        )
        setRouter(response.data)
      } catch {
        setFeedback({
          isOpen: true,
          message: 'Erro ao carregar detalhes do roteiro!',
          statusOk: false,
        })
        navigate('/panel/router/routers')
      } finally {
        setIsLoadingRouter(false)
      }
    }

    void fetchRouter()
  }, [router, routerId, setRouter, setFeedback, navigate])

  const DriverListener = () => {



    return (
      <>
        <DriverListDiv>
          <Text style={{ marginBottom: '0', marginTop: '0' }}>Motoristas</Text>

          {drivers.map((driver: any, index: number) => {
            return (
              <div
                key={index}
                style={{ height: '8rem', marginTop: '0.5rem', width: '100%' }}
              >
                <ButtonCreate
                  key={index}
                  style={{
                    flexGrow: 1,
                    height: '70%',
                    width: '100%',
                    marginBottom: '0.5rem',
                    textAlign: 'start',
                  }}
                  onClick={() => handleFeedback(driver.phone)}
                >
                  <div
                    style={{
                      width: '70%',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <p style={{ textAlign: 'center' }}>{driver.name}</p>
                  </div>{' '}
                  <div
                    style={{
                      width: '30%',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <IconImg
                      style={{
                        width: '1.3rem',
                        height: '1.3rem' ,
                      }}
                      src={send}
                    ></IconImg>
                  </div>
                </ButtonCreate>
              </div>
            )
          })}
        </DriverListDiv>
      </>
    )
  }

  const handleFeedback = (phoneNumber: string) => {
    const url = feedbackGenerator(router, phoneNumber)

    window.open(url, '_blank')
  }
  const urlShorter = async (url: string) => {
    try {
      const response = await axios.get(
        `https://tinyurl.com/api-create.php?url=${url}`,
      )
      const linkshort = response.data

      return linkshort
    } catch (error) {
      console.error('Failed to fetch short URL:', error)
    }
  }
  useEffect(() => {
    const fetchShortUrl = async () => {
      if (router && router.url) {
        try {
          const response = await axios.get(
            `https://tinyurl.com/api-create.php?url=${router.url}`,
          )
          const routerUtl = response.data

          setShortUrl(routerUtl)
        } catch (error) {
          console.error('Failed to fetch short URL:', error)
        }
      }
    }
    fetchShortUrl()
  }, [router])

  const feedbackGenerator = (router: any, phoneNumber: string) => {
    const freigths = router?.Freight


    const addresses = freigths
      .map((freight: any, index: number) => {
        return `
*Frete ${index + 1}:* 

*Tipo:* ${freight.type}
*Cliente:* ${freight.Company?.companyName || ''}
*Carga:* ${freight.Load ? `${freight.Load.weight}kg, ${freight.Load.length}x${freight.Load.width}x${freight.Load.height}` : '—'}
${freight.Load?.detail ? `*detalhe da carga:* ${freight.Load.detail}` : ''}
*Local:* ${freight.Address ? `${freight.Address.street}, ${freight.Address.number}` : '—'}
*Observação*: ${freight.observation || ''}
*Link:* ${mapsLinkGenerator(freight)}
`
      })
      .join('\n\n') 

    const message = `
*Olá! Uma rota foi atribuida a você*
        
*Data:* ${dataFormatter(router?.date)}
*Tempo estimado de trajeto:* ${router?.track.split('-')[0]}
*Distância:* ${router?.track.split('-')[1]}
        
*Pontos de entrega:*\n
${addresses}

*Rota completa:* ${shortUrl}\n   
> Ordeno`

    const encodedMessage = encodeURIComponent(message)


    const whatsappUrl = `https://wa.me/+55${phoneNumber}?text=${encodedMessage}`


    return whatsappUrl
  }

  const completeRoute = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/route/${router?.id}/completed`,
      )
      const responseRoute = await axios.get(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/route/${router?.id}`,
      )

      setRouter(responseRoute.data)
      setFeedback({
        isOpen: true,
        message: 'Rota completa!',
        statusOk: true,
      })
    } catch {
      setFeedback({
        isOpen: true,
        message: 'Erro ao concluir rota',
        statusOk: false,
      })
    }
  }
  const wazeLinkGenerator = (freight: Freight) => {
    if (!freight || !freight.Address) {
      console.warn("Objeto 'freight' ou 'freight.Address' inválido.")
      return ''
    }

    const street = freight.Address.street
    const number = freight.Address.number
    const neighborhood = freight.Address.Neighborhood.name
    const city = freight.Address.Neighborhood.City.name
    const state = freight.Address.Neighborhood.City.State.uf 



    const addressString = `${street}, ${number}, ${neighborhood}, ${city}, ${state}`



    const encodedAddress = encodeURIComponent(addressString)


    return `https://waze.com/ul?q=${encodedAddress}`
  }

  const mapsLinkGenerator = (freight: Freight) => {
    if (!freight || !freight.Address) {
      console.warn("Objeto 'freight' ou 'freight.address' inválido.")
      return ''
    }


    const street = freight.Address.street
    const number = freight.Address.number
    const neighborhood = freight.Address.Neighborhood.name
    const city = freight.Address.Neighborhood.City.name
    const state = freight.Address.Neighborhood.City.State.uf


    const addressString = `${street}, ${number}, ${neighborhood}, ${city}, ${state}`



    const encodedAddress = encodeURIComponent(addressString)



    return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`
  }
  const calculateVolume = (
    weight: number,
    height: number,
    length: number,
    width: number,
  ): string => {
    const volume = (height * length * width) / 1_000_000 
    const formattedWeight = weight.toLocaleString('pt-BR') 

    return `${volume.toFixed(3)}m³ ${formattedWeight}kg`
  }

  const generateCompleteMessage = (
    router: Router,
    complete: boolean,
    shortUrl: string,
  ) => {
    const freights = router?.Freight

    if (!freights || freights.length === 0) {
      return 'Nenhum frete encontrado.'
    }

    const generateFreightMessage = (
      freight: Freight,
      index: number,
      isComplete: boolean,
    ) => {
      let message = ''


      if (isComplete) {
        message += `*Frete ${index + 1} (${freight.type}) - `
      } else {
        message += `*${index + 1}º (${freight.type})* - ${
          freight.Company?.companyName || ''
        }`
        if (freight.observation) {
          message += ` - ${freight.observation}`
        }
        message += '\n'
      }

      if (isComplete) {
        if (freight.Company?.companyName) {
          message += `${freight.Company.companyName}*\n`
        }




        const dimensionParts = []
        if (Number(freight.Load?.length) > 0) {
          dimensionParts.push(`${freight.Load?.length}`)
        }
        if (Number(freight.Load?.width) > 0) {
          dimensionParts.push(`${freight.Load?.width}`)
        }
        if (Number(freight.Load?.height) > 0) {
          dimensionParts.push(`${freight.Load?.height}`)
        }


        const loadParts = []

        if (Number(freight.Load?.weight) > 0) {
          loadParts.push(`${freight.Load?.weight}kg`)
        }


        if (dimensionParts.length > 0) {
          loadParts.push(dimensionParts.join('x'))
        }

        if (freight.Load?.detail) {
          loadParts.push(`${freight.Load.detail}`)
        }

        if (loadParts.length > 0) {
          message += `*Carga:* ${loadParts.join(' / ')}\n`
        }

        if (freight.observation) {
          message += `*Obs:* ${freight.observation}\n`
        }
      }


      const addressParts = []
      if (freight.Address?.street) {
        addressParts.push(freight.Address.street)
      }
      if (freight.Address?.number) {
        addressParts.push(freight.Address.number)
      }
      if (freight.Address?.Neighborhood?.City?.name) {
        addressParts.push(freight.Address.Neighborhood.City.name)
      }
      if (addressParts.length > 0) {
        message += `*Local:* ${addressParts.join(', ')}\n`
      }


      const mapLink = mapsLinkGenerator(freight)
      if (mapLink) {
        message += `*Link:* ${mapLink}\n`
      }

      return message
    }


    const freightsMessages = freights
      .map((freight: Freight, index: number) =>
        generateFreightMessage(freight, index, complete),
      )
      .join('\n\n')


    if (complete === false) {
      const summaryMessage = `*Olá! Uma rota foi atribuída a você - Data: ${dataFormatter(
        router?.date,
      )}*\n\n${freightsMessages}\n\n*Rota completa:* ${shortUrl}\n`
      return summaryMessage
    } else {
      const fullMessage = `*Olá! Uma rota foi atribuída a você - Data: ${dataFormatter(
        router?.date,
      )}*\n\n*Tempo estimado de trajeto:* ${
        router?.track?.split('-')[0] || ''
      }\n*Distância:* ${
        router?.track?.split('-')[1] || ''
      }\n\n${freightsMessages}\n\n*Rota completa:* ${shortUrl}\n`
      return fullMessage
    }
  }

  /*   const generateCompleteMessage = (router: any, complete: boolean) => {
    const freigths = router?.freight

    const addresses = freigths
      .map((freight: any, index: number) => {
        return `
*Frete ${index + 1} (${freight.type})*: 
*Cliente:* ${freight.company.companyName}
*Carga:* ${freight.load.weight}kg, ${freight.load.length}x${
          freight.load.width
        }x${freight.load.height} / ${
          freight.load.detail
            ? `*detalhe da carga:* ${freight.load.detail}`
            : ''
        }
*Local:* ${freight.address.street}, ${freight.address.number} - ${
          freight.address.city
        }
*Observação*: ${freight.observation}
*Link:* ${mapsLinkGenerator(freight)}
`
      })
      .join('\n\n')
    const addressesResumed = freigths
      .map((freight: any, index: number) => {
        return `
*${index + 1}º (${freight.type})* - ${freight.company.companyName} - ${
          freight.observation
        }
*Local:* ${freight.address.street}, ${freight.address.number}
*Link:* ${mapsLinkGenerator(freight)}
`
      })
      .join('\n\n')

    if (complete === false) {
      const summaryMessage = `
*Olá! Uma rota foi atribuida a você - Data: ${dataFormatter(router?.date)}*
        
*Pontos de entrega:*\n
${addressesResumed}

*Rota completa:* ${shortUrl}\n`
      return summaryMessage
    } else {

      const fullMessage = `
*Olá! Uma rota foi atribuida a você - Data: ${dataFormatter(router?.date)}*

*Tempo estimado de trajeto:* ${router?.track.split('-')[0]}
*Distância:* ${router?.track.split('-')[1]}
        
*Pontos de entrega:*\n
${addresses}

*Rota completa:* ${shortUrl}\n`
      return fullMessage
    }
  }
 */
  const handleCopyComplete = async (complete: boolean) => {
    if (!router) {
      console.error('Dados da rota não disponíveis.')
      return
    }

    const textToCopy = generateCompleteMessage(router, complete, shortUrl)

    try {
      await navigator.clipboard.writeText(textToCopy)
      setFeedback({
        isOpen: true,
        message: 'Mensagem completa copiada!',
        statusOk: true,
      })
    } catch (err) {
      setFeedback({
        isOpen: true,
        message: 'Falha ao copiar a mensagem.',
        statusOk: false,
      })
      console.error('Falha ao copiar texto: ', err)
    }
  }

  const handlePrint = async () => {
    if (!router) return

    setIsPrinting(true)
    try {
      await printRoutePdf(router)
    } catch (error) {
      console.error('Erro ao imprimir roteiro:', error)
      setFeedback({
        isOpen: true,
        message: 'Erro ao preparar impressão do roteiro.',
        statusOk: false,
      })
    } finally {
      setIsPrinting(false)
    }
  }

  return (
    <>
      <ModalTest>
        <Container>
          <GridContainer>
            <HeaderDiv style={{ gridArea: 'titleNew' }}>
              <HeaderText>Roteiro: {router?.id}</HeaderText>
              <CloseDiv onClick={() => close()}>
                <CloseImg src={cross} alt='Close tab' />
              </CloseDiv>
            </HeaderDiv>

            <TextLabel style={{ gridArea: 'dateLabel' }}>Data:</TextLabel>
            <Text style={{ gridArea: 'date' }}>
              {' '}
              {dataFormatter(router?.date || '')}
            </Text>
            {inputs.map((input) => {
              const value = router?.[input.field]

              return (
                <React.Fragment key={input.field}>
                  <TextLabel style={{ gridArea: input.field + 'Label' }}>
                    {input.label}
                  </TextLabel>
                  <Text style={{ gridArea: input.field }}>
                    {input.field === 'Vehicle' &&
                    typeof value === 'object' &&
                    value !== null &&
                    !Array.isArray(value)
                      ? value.plate
                      : typeof value === 'string' || typeof value === 'number'
                      ? value
                      : '-'}
                  </Text>
                </React.Fragment>
              )
            })}
          </GridContainer>

          <Text style={{ marginLeft: '1.5rem', marginTop: '0.75rem', marginBottom: '0.5rem', flexShrink: 0 }}>Roteiro:</Text>

          <TableContainer>
            <Table>
              <HeaderRow>
                {headersLabel.map((header) => {
                  return <HeaderCell key={header}>{header}</HeaderCell>
                })}
              </HeaderRow>
              {router?.Freight.map((freight: Freight, index) => {
                return (
                  <ItemRow key={freight.id}>
                    <ItemCell>{index + 1}</ItemCell>
                    <ItemCell className='link'>{freight.id}</ItemCell>
                    <ItemCell>{freight.Company?.companyName || '—'}</ItemCell>
                    <ItemCell>{freight.type}</ItemCell>
                    <ItemCell>
                      {freight.Address
                        ? `${freight.Address.street}, ${freight.Address.number} - ${freight.Address.Neighborhood?.City?.name}/${freight.Address.Neighborhood?.City?.State?.uf}`
                        : '—'}
                    </ItemCell>
                    <ItemCell>
                      {freight.Load
                        ? calculateVolume(
                            Number(freight.Load.weight),
                            Number(freight.Load.height),
                            Number(freight.Load.length),
                            Number(freight.Load.width),
                          )
                        : '—'}
                    </ItemCell>
                    <ItemCell className='link'>
                      <a href={wazeLinkGenerator(freight)}>Acessar</a>
                    </ItemCell>
                  </ItemRow>
                )
              })}
            </Table>
          </TableContainer>
          <OptionsDiv>
            
            <ButtonCreate
              className='reverse'
              onClick={handlePrint}
              disabled={!router || isLoadingRouter || isPrinting}
            >
              <IconImg src={print}></IconImg>
              {isPrinting ? 'Preparando...' : 'Imprimir'}
            </ButtonCreate>
            
            <ButtonCreate onClick={() => handleEdit()}>
              <IconImg src={pen}></IconImg>
              Editar
            </ButtonCreate>
            <div
              style={{
                width: '20%',
                marginLeft: '0.5rem',
                marginRight: '0.5rem',
              }}
            >
              <ButtonCreate
                style={{ width: '90%' }}
                onClick={() => handleCopyComplete(true)}
              >
                <Copy
                  style={{ width: '1rem', height: '1rem', marginRight: '3px' }}
                ></Copy>
                Copiar rota
              </ButtonCreate>
            </div>
            
            <div
              style={{
                width: '20%',
                marginLeft: '0.5rem',
                marginRight: '0.5rem',
              }}
            >
              <ButtonCreate
                style={{ width: '90%' }}
                onClick={() => setVisibleDriver(!visibleDriver)}
              >
                <IconImg
                  style={{ width: '1rem', height: '1rem' }}
                  src={share}
                ></IconImg>
                Compartilhar
              </ButtonCreate>
              {visibleDriver ? <DriverListener /> : null}
            </div>
            <ButtonCreate
              onClick={async () => {
                await completeRoute()
              }}
            >
              <IconImg
                style={{ width: '1rem', height: '1rem' }}
                src={correct}
              ></IconImg>
              Concluir rota
            </ButtonCreate>
          </OptionsDiv>
        </Container>
      </ModalTest>
    </>
  )
}

export default RouterDetail

